import { RouteConfig } from 'vue-router'

const router: RouteConfig[] = [
  {
    path: '/policy',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/Policy/Index.vue') }
    ],
    meta: { requiresAuth: true }
  }
]

export default router
